import { LoadingButton } from '@mui/lab';
import { Stack } from '@mui/material';

import BaseTextField from '@/components/TextField';
import { styled } from '@/theme/styled';
import { getBorder } from '@/theme/utils';

import { CardProps } from './Card/types';

const Body = styled(Stack)(({ theme }) => ({
  background: theme.palette.background.subtle,
  width: '100vw',
  height: '100vh',
}));

Body.defaultProps = {
  justifyContent: 'center',
  alignItems: 'center',
};

const AuthCard = styled(Stack, {
  shouldForwardProp: (propName) => propName !== 'contained',
})<CardProps>(({ theme, contained }) => ({
  width: 320,
  [theme.breakpoints.up('sm')]: {
    width: 460,
  },
  ...(contained && {
    [theme.breakpoints.up('sm')]: {
      width: 460,
      padding: theme.spacing(8),
      borderLeft: getBorder(theme.palette.border.default, 1, 'dashed'),
      borderRight: getBorder(theme.palette.border.default, 1, 'dashed'),
      borderImage:
        'repeating-linear-gradient(180deg,#cccccc 0,#cccccc 4px,transparent 0,transparent 8px) 1',
      background: theme.palette.background.default,
      height: '100%',
    },
  }),
}));

const SubmitButton = styled(LoadingButton)({});

SubmitButton.defaultProps = {
  variant: 'contained',
  type: 'submit',
  size: 'medium',
  color: 'primary',
};

const Form = styled('form')({});

const TextField = styled(BaseTextField)({});
TextField.defaultProps = {
  labelProps: {
    sx: { backgroundColor: 'transparent' },
  },
};

export { Body, AuthCard, Form, SubmitButton, TextField };
